const categories = [
  'gen-1',
  'gen-2',
  'gen-3',
];

export default categories;
